import { render, staticRenderFns } from "./NewReleases.component.vue?vue&type=template&id=2274b5ea"
import script from "./NewReleases.component.vue?vue&type=script&lang=js"
export * from "./NewReleases.component.vue?vue&type=script&lang=js"
import style0 from "./NewReleases.component.vue?vue&type=style&index=0&id=2274b5ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports